module.exports = "/lucky-balls/img/bonus_green/hole.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_green/hole.png
// module id = 941
// module chunks = 0